export default [
  // 隐藏 banner 右边的 ColorOS 连接，ROM、bbs、cloud、oppo 等连接
  // 下面顺序不能改，到 hideColorOSVersion
  'hideOppo',
  'hideCloud',
  'hideBBS',
  'hideRom',
  'hideColorOSVersion',
  // 除欧盟、俄罗斯、哈萨克斯坦、墨西哥，及部分运营商市场要隐藏 Artist Wallpaper Project
  'hideArtist',
  // 底部左边的特殊 url 配置，仅台湾

  'faqUrl',
  'developerUrl',
  'youTubeUrl',
  // 隐藏底部global 第一条备注，仅台湾

  'hideGlobal',
  'hide10Remark'
];
